import { StaticPage } from '@dreamstack/accentro-contentful/src/components/StaticPage'
import { OnboardingContextProvider } from '@dreamstack/feature-components/src/onboarding/OnboardingContext'
import { SelfManagedOnboardingModal } from '@dreamstack/feature-components/src/onboarding/SelfManagedOnboardingModal'
import { fetchStaticPageData } from '@dreamstack/payload/src/lib/fetchStaticPageData'
import { getStaticPropsPlus } from '../lib/getStaticPropsPlus'

export default function Home() {
  return (
    <>
      <OnboardingContextProvider>
        <SelfManagedOnboardingModal />
      </OnboardingContextProvider>
      <StaticPage slug={'index'} />
    </>
  )
}

export const getStaticProps = getStaticPropsPlus({
  getProps: async () => {
    await fetchStaticPageData({ slug: 'index' })
  },
})
